import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type {
  OrganizationRoleWithRelationsDto,
  ResponseDto,
} from "@mimber/schema"
import { rolesKeys } from "../roles.utils"

/**
 * Organization-specific hook for fetching all organization roles
 * Can only be used in mimber-organization app
 */
export const useRoles = (
  options?: UseQueryOptions<
    ResponseDto<OrganizationRoleWithRelationsDto[]>,
    Error
  >
): UseQueryResult<ResponseDto<OrganizationRoleWithRelationsDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useRoles")

  const { server } = useServerContext()

  return useQuery({
    queryKey: rolesKeys.findAll(),
    queryFn: async () => {
      const response =
        await server.get<ResponseDto<OrganizationRoleWithRelationsDto[]>>(
          "roles"
        )
      return response.data
    },
    staleTime: 5 * 60 * 1000,
    ...options,
  })
}
